module.exports = __webpack_public_path__ + "static/media/img7.d7f35d3e.jpg";